module.exports = __webpack_public_path__ + "static/media/S3N5-1.e687418a.svg";